import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=b126caf4&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b126caf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b126caf4')) {
      api.createRecord('b126caf4', component.options)
    } else {
      api.reload('b126caf4', component.options)
    }
    module.hot.accept("./ShopItem.vue?vue&type=template&id=b126caf4&scoped=true&", function () {
      api.rerender('b126caf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Shops/ShopItem.vue"
export default component.exports